import { useRoutes } from "raviger";

import Landing from "./pages/Landing";
import Container from "./components/Container";

import "./App.css";
import Upload from "./pages/Upload";
import Certificate from "./pages/Certificate";
import CreatedCertificate from "./pages/CreatedCertificate";

function App() {
  const routes = {
    "/": () => <Landing />,
    "/upload": () => <Upload />,
    "/certificate/:id": ({ id }) => <Certificate certificate_id={id} />,
    "/created/:id": ({ id }) => <CreatedCertificate certificate_id={id} />,
  };

  let routeResult = useRoutes(routes);
  return <Container>{routeResult}</Container>;
}

export default App;
